/**
 * PATH: packages/ui/src/kanban/components/rightRailPhoneSheet.ts
 * FILE_ID: UI-KANBAN-RIGHT-RAIL-PHONE-SHEET-001
 * PURPOSE: Shared geometry + contrast tokens for Emails / Jobs / Card
 *   sheets on a phone-width pane.
 * WHY: The three rails used different wrappers (absolute 80vh vs full
 *   viewport), so swapping tabs jumped height/position and the Emails
 *   and Jobs headers (with their X) clipped under Job Hub overflow.
 * FLOW:
 *   ┌──────────┐   ┌─────────────┐   ┌──────────────┐
 *   │ isPhone  │ → │ this module │ → │ scrim+sheet  │
 *   └──────────┘   └─────────────┘   └──────────────┘
 */

export const RIGHT_RAIL_PHONE_SHEET_HEIGHT_CLASS = 'h-[92dvh] max-h-[92dvh]'

export const RIGHT_RAIL_PHONE_SCRIM_CLASS =
  'fixed inset-0 z-[55] bg-black/50 backdrop-blur-sm'

export const RIGHT_RAIL_PHONE_SHEET_CLASS = [
  'fixed inset-x-0 bottom-0 z-[56] flex w-full flex-col overflow-hidden',
  RIGHT_RAIL_PHONE_SHEET_HEIGHT_CLASS,
  'rounded-t-2xl border-t border-neutral-200 bg-white',
  'shadow-[0_-12px_48px_rgba(0,0,0,0.28)] ring-1 ring-black/15',
  'dark:border-zinc-800 dark:bg-zinc-900 dark:ring-white/15',
].join(' ')

/** Card drawer wrapper — same scrim + bottom-aligned sheet as the rails. */
export const RIGHT_RAIL_PHONE_CARD_WRAPPER_CLASS =
  'fixed inset-0 z-[55] flex items-end justify-stretch bg-black/50 backdrop-blur-sm'

export const RIGHT_RAIL_PHONE_CARD_ASIDE_CLASS = [
  'relative flex w-full flex-col overflow-hidden',
  RIGHT_RAIL_PHONE_SHEET_HEIGHT_CLASS,
  'rounded-t-2xl border-t border-neutral-200 bg-white',
  'shadow-[0_-12px_48px_rgba(0,0,0,0.28)] ring-1 ring-black/15',
  'dark:border-neutral-800 dark:bg-neutral-950 dark:ring-white/15',
].join(' ')

export function resolveRightRailPhoneChrome(isPhone: boolean): {
  useViewportSheet: boolean
  scrimClass: string
  sheetClass: string
} {
  return {
    useViewportSheet: isPhone,
    scrimClass: RIGHT_RAIL_PHONE_SCRIM_CLASS,
    sheetClass: RIGHT_RAIL_PHONE_SHEET_CLASS,
  }
}

/** Phone sheets are full-bleed. Desktop rails keep the persisted pixel width. */
export function resolveRightRailWidthStyle(
  useViewportSheet: boolean,
  width: number | undefined,
): { width?: number } {
  if (useViewportSheet || typeof width !== 'number') return {}
  return { width }
}
